export default __webpack_public_path__ + "static/media/banner-01_644x450_crop_center.aeace549.jpg";